var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircleCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.582031 68.5007C0.582031 31.0107 31.0087 0.583984 68.4987 0.583984C105.989 0.583984 136.415 31.0107 136.415 68.5007C136.415 105.991 105.989 136.417 68.4987 136.417C31.0087 136.417 0.582031 105.991 0.582031 68.5007ZM54.9154 83.2387L99.6725 38.4816L109.249 48.1258L54.9154 102.459L27.7487 75.2924L37.3249 65.7162L54.9154 83.2387Z",
    fill: "#00BC61"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle_check.05348daa.svg";
export { ForwardRef as ReactComponent };